'format es6';
'use strict';

import ArrayFindPolyfill from './array-find-polyfill';
import $ from 'jquery';
import ns from 'ns';

import Scroll from './Scroll';
import Menu from './sections/Menu';
import User from './User';

import { factory as homeFactory } from './sections/Home';
import { factory as instructionsFactory } from './sections/Instructions';
import { factory as profileQuizFactory } from './sections/ProfileQuiz';
import { factory as profileResultFactory } from './sections/ProfileResult';
import { factory as domainQuizFactory } from './sections/DomainQuiz';
import { factory as domainResultFactory } from './sections/DomainResult';

const ROOT_SELECTOR = '[data-content]';
const PROFILE_RESULT_KEY = 'user.profile_result';
const DOMAIN_RESULT_PARTIAL_KEY = 'user.domain_result';

const DOMAIN_SECTION_ID = 1;
const FAMILIES_SECTION_ID = 2;
const RESULTS_SECTION_ID = 3;

const getContainer = (() => {
	let container;
	return () => {
		if (container) return container;
		container = $(ROOT_SELECTOR);
		return container;
	};
})();

function showHome() {
	const section = ns.currentSection = homeFactory();
	const onReady = section.render(getContainer());
	onReady.then(() => {
		section.animateIn();
		section.onNext((skipInstructions) => {
			if (skipInstructions) {
				showProfileQuiz();
			} else {
				showInstructions();
			}
		});
	});
}

function showInstructions() {
	const section = ns.currentSection = instructionsFactory();
	const onReady = section.render(getContainer());
	onReady.then(() => {
		section.animateIn();
		section.onNext(showProfileQuiz);
	});
}

function showProfileQuiz() {
	const savedData = User.get(PROFILE_RESULT_KEY);
	ns.Menu.updateCurrentSection(DOMAIN_SECTION_ID);

	if (savedData !== null) {
		showProfileResult(savedData);
	} else {
		const section = ns.currentSection = profileQuizFactory();
		const onReady = section.render(getContainer());
		onReady.then(() => {
			section.animateIn();
			section.onNext(showProfileResult);
		});
	}
}

function showProfileResult(result,profilequestions=null) {
	const res = result || User.get(PROFILE_RESULT_KEY);
	const qstats = profilequestions;
	const section = ns.currentSection = profileResultFactory();
	section.setResult(res);
	section.setStats(qstats);
	const onReady = section.render(getContainer());
	onReady.then(() => {
		section.animateIn();
		section.onNext(showDomainQuiz);
	});
}

function showDomainQuiz(domain) {
	const savedData = User.get(`${DOMAIN_RESULT_PARTIAL_KEY}_${domain.id}`);
	ns.Menu.updateCurrentSection(FAMILIES_SECTION_ID);

	if (savedData !== null) {
		showDomainResult(savedData, true);
	} else {
		const section = ns.currentSection = domainQuizFactory();
		section.setDomain(domain);
		const onReady = section.render(getContainer());
		onReady.then(() => {
			section.animateIn();
			section.onNext(showDomainResult);
			section.onFail = showProfileResult;
		});
	}
}

function showDomainResult(result, hidePubs = false) {
	ns.Menu.updateData();
	ns.Menu.updateCurrentSection(RESULTS_SECTION_ID);

	const section = ns.currentSection = domainResultFactory();
	section.setResult(result);
	section.setPubSettings(hidePubs);

	const onReady = section.render(getContainer());
	onReady.then(() => {
		section.animateIn();

		// Go back if wanted
		section.onNext(showProfileQuiz);
	});
}

ns.docReady.then(() => {
	ns.Menu = new Menu(showProfileQuiz, showDomainQuiz);
	Scroll.init();

	showHome();
});
